<template lang="pug">
div.wagtail__video__wrapper
  .wagtail__video
    iframe(
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      data-flag-inst="lazy"
      :src="changeLink(value.video)")
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    changeLink(link) {
      return link.replace('watch?v=', 'embed/')
    }
  }
}
</script>

<style lang="scss" scoped>
.wagtail__video {
  &__wrapper {
    position: relative;
    width: 100%;
    overflow: hidden;
    padding-top: 56.25%;
  }
}

.wagtail__video:deep(>iframe) {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border: none;
}
</style>